<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">RPJMD</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="text-center" style="width: 3%">No.</th>
                            <th class="text-center" style="width: 8%">Periode</th>
                            <th class="text-center" style="width: 30%">Uraian Rpjmd</th>
                            <th class="text-center" style="width: 8%">Tahun Awal</th>
                            <th class="text-center" style="width: 8%">Tahun Akhir</th>
                            <th class="text-center" style="width: 10%" >Status RPJMD</th>
                            <th class="text-center" >No Perda</th>
                            <th class="text-center" >Tgl Perda</th>
                            <th class="text-center" style="width: 10%">#</th>
                        </tr>
                        </thead>
                        <tbody class="tabel_center" >
                          
                          <tr v-if="cek_load_data">
                            <td colspan="9" class="text-center">
                                <img src="images/loading-plan.gif" width="450px">
                            </td>
                          </tr>

                          <template v-if="!cek_load_data" >
                            <tr class="h_isitable" v-for="(data, index) in list_rpjmd" :key="data.rpjmd_id">
                              <td class="tabel_center text-center">{{index+1}}</td>
                              <td class="tabel_center text-center" >{{data.periode}}</td>
                              <td class="tabel_center">{{data.uraian}}</td>
                              <td class="tabel_center text-center" >{{data.tahun_awal}}</td>
                              <td class="tabel_center text-center" >{{data.tahun_akhir}}</td>
                              <td class="tabel_center text-center" >{{data.status}}</td>
                              <td class="tabel_center ">{{data.no_perda}}</td>
                              <td class="tabel_center text-center" >{{data.tgl_perda | dateCut}}</td>
                              <td class="tabel_center text-center" >

                                  <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                      <i class="material-icons" >create</i>
                                  </button>
                                  &nbsp;
                                  <button @click="removeData(data.rpjmd_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                      <i class="material-icons" >clear</i>
                                  </button>

                              </td>
                            </tr>

                          </template>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                            <form @submit.prevent="addData()">

                            <div class="modal-body">

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Periode</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="data.periode" type="text" class="form-control" placeholder="Ex : 2016-2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Uraian Rpjmd</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input :required="true" v-model="data.uraian" type="text" class="form-control" placeholder="Ex : RPJMD Tahun 2016-2021 terdiri dari X Bab">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tahun Awal</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="data.tahun_awal" type="text" class="form-control" placeholder="Ex : 2016">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tahun Akhir</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="data.tahun_akhir" type="text" class="form-control" placeholder="Ex : 2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Status RPJMD</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select :required="true" v-model="data.status" class="form-control show-tick" tabindex="-98">
                                            <option disabled>-- Pilih Status RPJMD --</option>
                                            <option>Draft</option>
                                            <option>Final</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">No Perda</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="data.no_perda" type="text" class="form-control" placeholder="Ex : 2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tgl Perda</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="data.tgl_perda" type="date" class="datepicker form-control" placeholder="Please choose a date..." data-dtp="dtp_76UJ1">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Keterangan </label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <textarea :required="true" v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Periode</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input type="hidden" v-model="rpjmd_id">
                                        <input :required="true" v-model="periode" type="text" class="form-control" placeholder="Ex : 2016-2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Uraian Rpjmd</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input :required="true" v-model="uraian" type="text" class="form-control" placeholder="Ex : RPJMD Tahun 2016-2021 terdiri dari X Bab">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tahun Awal</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="tahun_awal" type="text" class="form-control" placeholder="Ex : 2016">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tahun Akhir</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="tahun_akhir" type="text" class="form-control" placeholder="Ex : 2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Status RPJMD</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select :required="true" v-model="status" class="form-control show-tick" tabindex="-98">
                                            <option disabled>-- Pilih Status RPJMD --</option>
                                            <option :selected="data.status==status">Draft</option>
                                            <option :selected="data.status==status">Final</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">No Perda</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="no_perda" type="text" class="form-control" placeholder="Ex : 2021">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Tgl Perda {{tgl_perda}}</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input :required="true" v-model="tgl_perda" type="date" class="datepicker form-control" placeholder="Please choose a date..." data-dtp="dtp_76UJ1">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Keterangan </label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_rpjmd/';


    export default {
        name: "planning_rpjmd",
        data() {
            return {
                data:{
                    rpjmd_id:'',
                    periode:'',
                    uraian:'',
                    tahun_awal:'',
                    tahun_akhir:'',
                    status:'',
                    no_perda:'',
                    tgl_perda:'',
                    keterangan:''
                },
                rpjmd_id:'',
                periode:'',
                uraian:'',
                tahun_awal:'',
                tahun_akhir:'',
                status:'',
                no_perda:'',
                tgl_perda:'',
                keterangan:'',
                list_rpjmd: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                  this.list_rpjmd = data_rpjmd.data;
                  this.page_last = data_rpjmd.jml_data;
                  this.cek_load_data = false;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                      rpjmd_id:this.rpjmd_id,
                      periode:this.periode,
                      uraian:this.uraian,
                      tahun_awal:this.tahun_awal,
                      tahun_akhir:this.tahun_akhir,
                      status:this.status,
                      no_perda:this.no_perda,
                      tgl_perda:this.tgl_perda,
                      keterangan:this.keterangan
                    })
                }).then((res_data) => {
                  console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
              this.rpjmd_id = data.rpjmd_id;
              this.periode = data.periode;
              this.uraian = data.uraian;
              this.tahun_awal = data.tahun_awal;
              this.tahun_akhir = data.tahun_akhir;
              this.status = data.status;
              this.no_perda = data.no_perda;
              this.tgl_perda = data.tgl_perda;
              this.keterangan = data.keterangan;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
              this.data={
                  rpjmd_id:'',
                  periode:'',
                  uraian:'',
                  tahun_awal:'',
                  tahun_akhir:'',
                  status:'',
                  no_perda:'',
                  tgl_perda:'',
                  keterangan:''
              };
              this.periode='';
              this.uraian='';
              this.tahun_awal='';
              this.tahun_akhir='';
              this.status='';
              this.no_perda='';
              this.tgl_perda='';
              this.keterangan='';
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
